import { SurveyFlow } from './survey/SurveyFlow.tsx';
import { AdminApp } from './admin/AdminApp.tsx';

export function App() {
  const segments = window.location.pathname.split('/').filter(Boolean);
  // /admin* -> Wipro admin console; /survey/:slug -> respondent survey
  if (segments[0] === 'admin') return <AdminApp />;
  if (segments[0] === 'survey') return <SurveyFlow slug={segments[1] ?? 'corning'} />;
  // Legacy: /:slug still works for backwards compat
  if (segments[0] && segments[0] !== 'survey') return <SurveyFlow slug={segments[0]} />;
  return <SurveyFlow slug="corning" />;
}
